import { SET_URL, INIT_APP } from '../constants/types';
import { initUrl } from '../lib/UrlUtils';

// Define initial state.
const initialState = {
  country: 'US',
  language: 'en',
  locale: 'en_US',
  api: {
    locations: '',
    locationDetails: '',
    token: '',
  },
  url: initUrl(window.location),
  performance: {
    progressiveLocations: false,
  },
};

// Define reducer.
export default (state = initialState, action) => {
  switch (action.type) {
    case INIT_APP:
      return {
        ...state,
        ...action.app,
      };
    case SET_URL:
      return {
        ...state,
        url: action.url,
      };
    default:
      return state;
  }
};
